import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const getPhasesByPropertyType = async (propertyTypeId) => {
  const ROUTE = urlConfig.backend.routes.phases.getPhasesByPropertyType;
  const url = `${BACKEND_URL}${ROUTE}`;

  if (propertyTypeId == null || Number.isNaN(Number(propertyTypeId))) {
    return {
      error_code: 3,
      error_message: "Missing or invalid property type.",
    };
  }

  return await axios
    .get(url, { params: { property_type_id: Number(propertyTypeId) } })
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something went wrong. Please try again later.",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      if (status === 422 || status === 400 || status === 405) {
        const msg =
          typeof data?.message === "string"
            ? data.message
            : typeof data?.detail === "string"
              ? data.detail
              : Array.isArray(data?.errors)
                ? data.errors.join(", ")
                : "Request could not be completed.";
        return {
          error_code: 3,
          error_message: msg,
          errors: data?.errors,
        };
      }
      return {
        error_code: 3,
        error_message:
          typeof data?.message === "string"
            ? data.message
            : error.message || "Request failed",
      };
    });
};
